<template>
  <v-app-bar app
             fixed
             id="app-bar"
             color="white"
             rounded>
    <router-link to="/home"
                 class="mb-2">
      <v-img src="../../assets/img/logo.svg"
             alt="ASCancer Atlas"
             position="left, center"
             contain></v-img>
    </router-link>

    <!-- PC -->
    <v-list class="d-none d-sm-none d-md-flex d-lg-flex align-center">
      <v-list-item to="/home"
                   active-class="atcive-style">
        <v-icon left>mdi-home-circle</v-icon>
        <span>Home</span>
      </v-list-item>

      <v-menu open-on-hover
              bottom
              offset-y
              rounded="lg">
        <template v-slot:activator="{on, attrs}">
          <v-list-item active-class="atcive-style"
                       v-bind="attrs"
                       v-on="on"
                       style="cursor:auto">
            <v-icon left>mdi-eye-circle</v-icon>
            <span>Browse</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-list-item>
        </template>
        <v-list dense>
          <v-list-item v-for="(item, index) in browses"
                       :key="index"
                       :to="item.path">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu open-on-hover
              bottom
              offset-y
              rounded="lg">
        <template v-slot:activator="{on, attrs}">
          <v-list-item to=""
                       v-bind="attrs"
                       v-on="on"
                       active-class="atcive-style"
                       style="cursor:auto">
            <v-icon left>mdi-database</v-icon>
            <span>Projects</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-list-item>
        </template>
        <v-list dense>
          <v-list-item v-for="(item, index) in projects"
                       :key="index"
                       :to="item.path">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-list-item to="/splicevis?genename=EZH2&astype=ES&coordinate=148515129%3A148515209%3A148516070%3A148516151%3A148516688%3A148516779"
                   active-class="atcive-style">
        <v-icon left>mdi-tune</v-icon>
        <span>Visualize</span>
      </v-list-item>

      <v-menu open-on-hover
              bottom
              offset-y
              rounded="lg">
        <template v-slot:activator="{on, attrs}">
          <v-list-item to="/tools"
                       v-bind="attrs"
                       v-on="on"
                       active-class="atcive-style">
            <v-icon left>mdi-toolbox</v-icon>
            <span>Toolkit</span>
            <v-icon right>mdi-menu-down</v-icon>
          </v-list-item>
        </template>
        <v-list dense>
          <v-list-item v-for="(item, index) in toolkit"
                       :key="index"
                       :to="item.path">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-list-item to="/download"
                   active-class="atcive-style">
        <v-icon left>mdi-briefcase-download</v-icon>
        <span>Download</span>
      </v-list-item>

      <!-- <v-list-item to="/statistic"
                   active-class="atcive-style">
        <v-icon left>mdi-chart-box</v-icon>
        <span>Statistics</span>
      </v-list-item> -->

      <v-list-item to="/help"
                   active-class="atcive-style">
        <v-icon left>mdi-help-box</v-icon>
        <span>Help</span>
      </v-list-item>
    </v-list>

    <!-- Phone -->
    <v-menu v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm"
            :close-on-content-click="false"
            bottom
            offset-x
            offset-y
            rounded="lg"
            v-model="isShowMenu">
      <template v-slot:activator="{on, attrs}">
        <v-list-item active-class="atcive-style"
                     v-bind="attrs"
                     v-on="on"
                     style="justify-content: end;">
          <v-icon left>mdi-apps</v-icon>
        </v-list-item>
      </template>
      <v-list dense>
        <v-list-item to="/home"
                     active-class="atcive-style"
                     @click="isShowMenu = false">
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>

        <v-list-group :value="false"
                      no-action
                      prepend-icon=""
                      append-icon="mdi-menu-down">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-eye-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Browse</v-list-item-title>
          </template>
          <v-list-item v-for="(item, index) in browses1"
                       :key="index"
                       :to="item.path"
                       @click="isShowMenu = false">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-group :value="false"
                      no-action
                      prepend-icon=""
                      append-icon="mdi-menu-down">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-database</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Projects</v-list-item-title>
          </template>
          <v-list-item v-for="(item, index) in projects"
                       :key="index"
                       :to="item.path"
                       @click="isShowMenu = false">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <v-list-item to="/splicevis?genename=EZH2&astype=ES&coordinate=148515129%3A148515209%3A148516070%3A148516151%3A148516688%3A148516779"
                     active-class="atcive-style"
                     @click="isShowMenu = false">
          <v-list-item-icon>
            <v-icon>mdi-tune</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Visualize</v-list-item-title>
        </v-list-item>

        <v-list-group :value="false"
                      no-action
                      prepend-icon=""
                      append-icon="mdi-menu-down">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>mdi-toolbox</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Toolkit</v-list-item-title>
          </template>
          <v-list-item v-for="(item, index) in toolkit"
                       :key="index"
                       :to="item.path"
                       @click="isShowMenu = false">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list-group>

        <!-- <v-menu open-on-hover
                bottom
                offset-y
                rounded="lg">
          <template v-slot:activator="{on, attrs}">
            <v-list-item to="/tools"
                         v-bind="attrs"
                         v-on="on"
                         active-class="atcive-style">
              <v-icon left>mdi-toolbox</v-icon>
              <span>Toolkit</span>
              <v-icon right>mdi-menu-left</v-icon>
            </v-list-item>
          </template>
          <v-list dense>
            <v-list-item v-for="(item, index) in toolkit"
                         :key="index"
                         :to="item.path">
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->

        <v-list-item to="/download"
                     active-class="atcive-style"
                     @click="isShowMenu = false">
          <v-list-item-icon>
            <v-icon>mdi-briefcase-download</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Download</v-list-item-title>
        </v-list-item>

        <v-list-item to="/help"
                     active-class="atcive-style"
                     @click="isShowMenu = false">
          <v-list-item-icon>
            <v-icon>mdi-help-box</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Help</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import * as d3 from 'd3-selection'
export default {
  name: 'AppBar',
  data() {
    return {
      selected: null,
      projects: [
      { text: 'TCGA', path: '/projects/tcga' },
      { text: 'GTEx', path: '/projects/gtex' },
      { text: 'GEO', path: '/projects/geo' },
      { text: 'Cell Type Atlas', path: '/projects/cell-atlas' },
      ],
      toolkit: [{ text: 'Splicing Regulatory Network', path: '/tools/regnet' },
      { text: 'Splicing Regulatory Explorer', path: '/tools/regexp' },
      { text: 'Survival Analysis', path: '/tools/survival/asevent' },
      { text: 'Cancer Staging Analysis', path: '/tools/stage/asevent' },
      { text: 'Splicing-derived Drug Response', path: '/tools/splicedrug' },
      { text: 'Isoform-specific PPIs Network', path: '/tools/spliceinter' },
      ],
      browses: [{ text: 'CASE (Cancer Associated Splicing Events)', path: '/browse/knowledge' },
      { text: 'CPSE (Computationally Putative Splicing Events)', path: '/browse/datasets' },
      ],
      browses1: [{ text: 'CASE', path: '/browse/knowledge?page=1&size=15' },
      { text: 'CPSE', path: '/browse/datasets?page=1&size=15&showpages=8' },
      ],
      isShowMenu: false
    }
  },
  mounted() {
    setTimeout(() => {
      d3.select('div.v-responsive__content').style('width', '300px');// 解决 Safari 兼容问题
      d3.select('div.v-responsive__sizer').style('padding-bottom', '23.6667%');// 解决 Firefox 兼容问题
    }, 200);
  },
  watch: {
    // $route(to, from) {
    // console.log(to);
    // console.log(to.path);
    // console.log(to.path.split('/')[1]);
    // if (to.path.split('/').length > 2) {
    //   console.log(to.path.split('/')[2]);
    // }
    // this.changeBreadItems(to);
    // }
  },
  methods: {
  },
}
</script>

<style scoped lang="sass">
.v-list .v-list-item--active
  color: #2196f3

.atcive-style
  background-color: #e0e0e0

::v-deep .v-responsive__content
  width: 300px
</style>
